interface MonthXTickProps {
    x: number;
    y: number;
    payload: {
        value: string | number;
    };
}

export default function MonthXTick({ x, y, payload }: MonthXTickProps) {
    return (
        <text x={x} y={y + 15} fill="#666" fontSize="12px" fontWeight="bold" textAnchor="middle">
            {payload.value}
        </text>
    );
}
